import React, { memo, ReactElement } from "react";
import { ArrowSvgIcon } from "@payment-ui/widgets/arrow-svg-icon";
import { useEffectOnce } from "@swiggy-private/core-ui";
import { capitalizeFirstLetter } from "@payment-ui/helpers/String";

import styles from "./TryOtherPaymentMethods.v4.scss";

interface TryOtherPaymentMethodsProps {
    onClick: VoidFunction;
    title: string;
    onImpression: VoidFunction;
}

const TryOtherPaymentMethods = (props: TryOtherPaymentMethodsProps): ReactElement => {
    useEffectOnce(() => {
        props.onImpression();
    });

    return (
        <div className={styles.otherPaymentMethods} onClick={props.onClick}>
            <div>{capitalizeFirstLetter(props.title)}</div>
            <ArrowSvgIcon className={styles.arrowIcon} />
        </div>
    );
};

export default memo(TryOtherPaymentMethods);
